export default __webpack_public_path__ + "static/media/archive.846e26d9.svg";